import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BachContext = createContext(null);

export function BachProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saveStatus, setSaveStatus] = useState("idle");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/bach/profile");
      setProfile(data.profile);
    } catch {
      setProfile(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async (patch) => {
    setSaveStatus("saving");
    setProfile((p) => ({ ...(p || {}), ...patch }));
    try {
      const { data } = await api.put("/bach/profile", patch);
      setProfile(data.profile);
      setSaveStatus("saved");
      setTimeout(() => setSaveStatus("idle"), 1500);
    } catch {
      setSaveStatus("error");
    }
  };

  const createProfile = async (payload) => {
    const { data } = await api.post("/bach/profile", payload);
    setProfile(data.profile);
    return data.profile;
  };

  return (
    <BachContext.Provider value={{ profile, setProfile, loading, save, createProfile, saveStatus, load }}>
      {children}
    </BachContext.Provider>
  );
}

export const useBach = () => useContext(BachContext);
